import React, { useMemo } from 'react';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import entryPoint from './entrypoint';

export function AutomationLimitsDialog() {
	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });
	const entryPointProps = useMemo(() => ({ onClose }), [onClose]);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointProps={entryPointProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
